import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { TranslateModule } from '@ngx-translate/core';

import { AuthorizationRoutingModule } from './authorization-routing.module';

import { AuthorizationPageComponent } from '@modules/authorization/components';
import { HeaderComponent } from '@modules/shared/components';
import { effects, reducers } from '@modules/authorization/store';

@NgModule({
  declarations: [AuthorizationPageComponent],
  imports: [
    CommonModule,
    AuthorizationRoutingModule,
    StoreModule.forFeature('authorization', reducers),
    EffectsModule.forFeature([...effects]),
    TranslateModule,
    HeaderComponent,
  ],
})
export class AuthorizationModule {}
